import Big from 'big.js'

// Helpers that map donation state into the shape Stripe's
// ExpressCheckoutElement expects in its onClick resolve(). Lives outside
// the step component because it's a pure transformation; useful in tests
// once Phase 7 spec coverage lands.

// Major-units to Stripe minor-units. Big.js (rather than Math.round on a
// float multiply) is here because line items run on raw donor-entered
// amounts plus tip / fee values that can be sub-cent fractions — an
// unrounded float multiply would drift on the rare exotic-exponent
// currency.
export const toStripeAmount = (amount, currency) =>
  Number(Big(amount || 0).times(10 ** (currency.exponent || 0)).round())

// ExpressCheckoutElement format: [{ name, amount }, ...]. The wallet
// sheet renders these as a breakdown above the total, so each line is
// independently labelled rather than merged into a single "Donation +
// tip + fees" string.
//
// Tip and cover-costs lines are independent: v7's donation.total sums
// both when both are active (unlike v6 where they were mutually
// exclusive), so the breakdown has to do the same or the line items
// won't add up to the total the wallet sheet displays.
export const buildLineItems = ({ i18n, donation }) => {
  const { state, currency, tip, fees } = donation
  const items = [{
    name: i18n.t(`subscription_labels.${state.subscription}.lineItem`),
    amount: toStripeAmount(state.amount, currency),
  }]
  if (Number(tip)) items.push({
    name: i18n.t(`subscription_labels.${state.subscription}.tipToPledge`),
    amount: toStripeAmount(tip, currency),
  })
  if (state.coverCosts) items.push({
    name: i18n.t('credit_card_fees'),
    amount: toStripeAmount(fees, currency),
  })
  return items
}

// Apple Pay's wallet sheet shows this as the merchant name above the
// total. directly_disbursed partners disburse to the org themselves;
// for Pledge-disbursed partners the donor is technically transacting
// with Pledge, so we add the via-Pledge wrapper to make that legible.
export const businessName = ({ creditCardProps, partnerItem, i18n }) =>
  creditCardProps?.directlyDisbursed
    ? partnerItem.beneficiary.name
    : i18n.t('via_pledge', { org: partnerItem.beneficiary.name })
